import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Article from '@/views/Article.vue'
import answers from '@/assets/answers'

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/article/:id",
            name: "article",
            component: Article,
            props: true,
            meta: {
                analytics: {
                    pageviewTemplate (route) {
                        const name = answers[route.params.id].short;
                        return {
                            title: name,
                            page: name
                        }
                    }
                }
            }
        },
        {
            path: "/about",
            name: "about",
            component: () => import('./views/About.vue')
        },
        {
            path: "/impressum",
            name: "impressum",
            component: () => import('./views/Impressum.vue')
        },
        {
            path: "/datenschutz",
            name: "datenschutz",
            component: () => import('./views/Datenschutz.vue')
        },
        {
            path: "/editor",
            name: "editor",
            component: () => import('./views/Editor.vue')
        },
        {
            path: "/weihnachtsfriede",
            name: "weihnachtsfriede",
            component: () => import('./views/Weihnachtsfriede.vue'),
        }
    ],
    scrollBehavior: (to, from, savedPosition) => {
        return savedPosition || {x: 0, y: 0};
    }
});

// Redirect if path begins with a hash (ignore hashes later in path)
router.beforeEach((to, from, next) => {
    // Redirect if fullPath begins with a hash (ignore hashes later in path)
    if (to.fullPath.substr(0, 2) === '/#') {
        const path = to.fullPath.substr(2);
        next(path);
        return;
    }
    next();
});

router.beforeEach((to, from, next) => {
    switch (to.name) {
        case "article": {
            document.title = answers[to.params.id].short;
            break;
        }
        case "editor": {
            document.title = "Wersglaubt Editor";
            break;
        }
        default: {
            document.title = "Wer's glaubt...";
            break;
        }
    }
    next();
});

export default router;
